import React, { Component } from "react";
import MarketplaceDashboard from '../home/MarketplaceDashboard';

class MarketplaceGlobal extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		globalOpen: true,
		openSessionPopup: ''
    }
}
 
componentDidMount(){
	
}

  render() {
	 return (
		<div>
			<MarketplaceDashboard
				parentComponent='marketplaceglobal'
			></MarketplaceDashboard>
		</div>
    );
  }
}
export default MarketplaceGlobal;